import React from 'react'
import './abouthero.less'

export default ()=>{
    return(
        <section className="about-hero">
            <h1>
                About Us
            </h1>
        </section>
    )
}